module.exports = __webpack_public_path__ + "static/media/values_1366.7e71c62e.png";